import { postFile } from '@/http'

const FORMATS = 'JPEG,PNG,PDF,DOC,DOCX,XLS,XLSX,CSV'
const ALLOWED_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv'])
const MAX_FILES = 10
const MAX_FILE_SIZE = 20 * 1024 * 1024

function extension(file) {
  const parts = String(file?.name || '').toLowerCase().split('.')
  return parts.length > 1 ? parts.pop() : ''
}

export function appendSupportFiles(currentFiles, incomingFiles) {
  const current = currentFiles || []
  const incoming = Array.from(incomingFiles || [])
  if (current.length + incoming.length > MAX_FILES) {
    return { files: current, error: 'Attach no more than 10 files.' }
  }
  const tooLarge = incoming.find(file => file.size > MAX_FILE_SIZE)
  if (tooLarge) {
    return { files: current, error: `${tooLarge.name} is larger than 20 MB.` }
  }
  const unsupported = incoming.find(file => !ALLOWED_EXTENSIONS.has(extension(file)))
  if (unsupported) {
    return { files: current, error: `${unsupported.name} is not a supported file type.` }
  }
  return { files: [...current, ...incoming], error: '' }
}

export function clipboardSupportFiles(event) {
  const files = Array.from(event?.clipboardData?.files || [])
  if (files.length) event.preventDefault()
  return files
}

export async function uploadSupportFiles(files) {
  const uploaded = []
  for (const file of files || []) {
    const data = new FormData()
    data.append('file', file)
    data.append('file_name', file.name)
    data.append('formats', FORMATS)
    const response = await postFile(data)
    uploaded.push(response.data)
  }
  return uploaded
}
